import React, { Component } from "react";
import axios from "axios";
import "bulma/css/bulma.css";

const getContent = async plateNumber => {
  try {
    const response = await axios
      .create({
        baseURL: "https://back.ufodrive.com/ufodrive/1.0.0/public/api/v2/cars/",
        timeout: 60000
      })
      .get(plateNumber);
    return response.data.content;
  } catch (error) {
    return [];
  }
};

class App extends Component {
  constructor(props) {
    super(props);

    // default State object
    this.state = {
      faq_categories: [],
      selected_reference: "",
      modal_faq_reference: ""
    };
  }

  async componentWillMount() {
    await this.refreshContent();
    await setInterval(this.refreshContent, 3600000);
  }

  refreshContent = async () => {
    let carReference = window.location.pathname
      .replace("/", "")
      .replace(" ", "");
    let content = await getContent(carReference);
    if (content && Array.isArray(content) && content.length > 0) {
      this.setState({
        faq_categories: content,
        selected_reference: content
          ? content[0]
            ? content[0].reference
            : null
          : null,
        modal_faq_reference: ""
      });
    }
  };

  handleCategoryClick = reference => e => {
    e.preventDefault();

    this.setState({
      ...this.state,
      selected_reference: reference
    });
  };

  handleMediaClick = reference => e => {
    e.preventDefault();

    this.setState({
      ...this.state,
      modal_faq_reference: reference
    });
  };

  exist(object) {
    return object !== null && object !== undefined && object !== "";
  }

  render() {
    let faq_categories = this.state.faq_categories
      ? this.state.faq_categories
      : null;
    let selected_faq_category = null;
    if (
      faq_categories &&
      Array.isArray(faq_categories) &&
      faq_categories.length > 0
    ) {
      selected_faq_category = faq_categories.find(
        faq_category => faq_category.reference === this.state.selected_reference
      );
    }
    let modal_faq_reference = this.state.modal_faq_reference;

    if (!selected_faq_category) {
      return (
        <div className="hero-body">
          <div>
            Please insert the plate number (case sensitive, no space) to the
            url. i.e. https://car.ufodrive.com/JE5728
          </div>
          <br />
          <div>
            In case of support, please open the chat and escalate in the
            operation app (https://operation.ufodrive.com)
          </div>
        </div>
      );
    }

    return (
      <section className="hero is-ufo is-fullheight">
        <div className="hero-head">
          <section className="section">
            <div className="columns is-centered">
              <div className="column" />
              <div className="column">
                <figure className="image">
                  <img
                    src={
                      "https://resources.ufodrive.com/carScreen/images/UFOLogo.png"
                    }
                    alt="logo"
                  />
                </figure>
              </div>
              <div className="column" />
            </div>
            <article className="notification is-ufosecondary  has-text-centered">
              <p className="title is-2">Welcome</p>
              <p className="subtitle is-3">Enjoy your UFODRIVE experience.</p>
            </article>
          </section>
        </div>
        <div className="hero-body">
          <div className="columns">
            <div className="column is-one-fifth">
              {faq_categories.map(faq_category => (
                <div key={faq_category.reference}>
                  <a onClick={this.handleCategoryClick(faq_category.reference)}>
                    {selected_faq_category.reference ===
                      faq_category.reference && (
                      <article className="notification is-ufosecondary">
                        <p className="title is-4">{faq_category.name}</p>
                        <p className="subtitle is-5">
                          {faq_category.description}
                        </p>
                      </article>
                    )}
                    {selected_faq_category.reference !==
                      faq_category.reference && (
                      <article className="notification">
                        <p className="title is-4 has-text-ufo">
                          {faq_category.name}
                        </p>
                        <p className="subtitle is-5 has-text-ufo">
                          {faq_category.description}
                        </p>
                      </article>
                    )}
                  </a>
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              ))}
            </div>
            <div className="column">
              <div className="box">
                {selected_faq_category.faqs.map(faq => (
                  <article
                    className="media"
                    key={selected_faq_category.reference + "-" + faq.reference}
                  >
                    {this.exist(faq.icon) && (
                      <span
                        className={"icon is-large media-left " + faq.icon_color}
                      >
                        <i className={"fas " + faq.icon + " fa-3x"} />
                      </span>
                    )}
                    <div className="media-content">
                      <div className="content">
                        <p className="title is-4 has-text-ufo">{faq.title}</p>
                        {this.exist(faq.description) && (
                          <p className="subtitle is-5 has-text-ufo">
                            {" " + faq.description}
                          </p>
                        )}
                        <div className="columns">
                          <div className="column">
                            {this.exist(faq.text) && (
                              <p className="subtitle is-5 has-text-ufo">
                                {faq.text}
                              </p>
                            )}
                            {this.exist(faq.texts) && (
                              <ul className="subtitle is-5 has-text-ufo">
                                {faq.texts.map((text, index) => (
                                  <li key={index}>{text}</li>
                                ))}
                              </ul>
                            )}
                          </div>
                          {this.exist(faq.media) && (
                            <div className="column is-one-third">
                              <div
                                className={
                                  modal_faq_reference === faq.reference
                                    ? "modal is-active"
                                    : "modal"
                                }
                              >
                                <div
                                  className="modal-background"
                                  onClick={this.handleMediaClick("")}
                                />
                                <div className="modal-content">
                                  <figure className="image">
                                    <img src={faq.media} alt={faq.title} />
                                  </figure>
                                </div>
                                <button
                                  className="modal-close is-large"
                                  aria-label="close"
                                  onClick={this.handleMediaClick("")}
                                />
                              </div>
                              <a onClick={this.handleMediaClick(faq.reference)}>
                                <figure className="image is-512x512 ">
                                  <img src={faq.media} alt={faq.title} />
                                </figure>
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                      {this.exist(faq.info) && (
                        <article className="message is-info is-medium">
                          <div className="message-body">
                            <p>{faq.info}</p>
                          </div>
                        </article>
                      )}
                      {this.exist(faq.warning) && (
                        <article className="message is-warning  is-medium">
                          <div className="message-body">{faq.warning}</div>
                        </article>
                      )}
                      {this.exist(faq.danger) && (
                        <article className="message is-danger  is-medium">
                          <div className="message-body">{faq.danger}</div>
                        </article>
                      )}
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="hero-foot">
          <div className="content has-text-centered">
            <article className="notification is-ufosecondary  has-text-centered">
              <p className="subtitle is-5">
                If you have any questions or need assistance please call
                UFODRIVE on +352206057.
              </p>
            </article>
          </div>
        </div>
      </section>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js